import { ARCHIVE_CACHE_HEADERS } from "@/lib/ssrCache";
import { createFileRoute } from "@tanstack/react-router";
import BrowseArchive from "@/components/BrowseArchive";
import { fetchBrowseEntries } from "@/lib/browseIndex";

export const Route = createFileRoute("/browse/")({
  loader: async () => await fetchBrowseEntries(),
  headers: () => ARCHIVE_CACHE_HEADERS,
  head: () => ({
    meta: [
      { title: "Browse All Pages | Garden-Review UK" },
      {
        name: "description",
        content:
          "Complete index of Garden-Review: every garden machinery review, buying guide, plant guide and category page in one browsable A–Z archive.",
      },
      { property: "og:title", content: "Browse All Pages | Garden-Review UK" },
      {
        property: "og:description",
        content:
          "Every Garden-Review page in one place — reviews, buying guides, plant guides and product pages.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.garden-review.co.uk/browse" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://www.garden-review.co.uk/browse" }],
  }),
  component: () => <BrowseArchive entries={Route.useLoaderData()} page={1} />,
});
